import {isNotNil} from 'ramda';

import {CampaignFilter} from '@dms/api/shared';

import {Nullish} from 'shared/web';

const RANGE_FIELDS = [
  ['priceFrom', 'priceTo'],
  ['mileageFrom', 'mileageTo'],
  ['yearFrom', 'yearTo'],
] as const;

// The upper bound of every range whose lower bound lies above it.
export const getDescendingVehicleSelectionRanges = (filter: CampaignFilter | Nullish) =>
  RANGE_FIELDS.filter(([fromField, toField]) => {
    const from = filter?.[fromField];
    const to = filter?.[toField];

    return isNotNil(from) && isNotNil(to) && to < from;
  }).map(([, toField]) => toField);
